import _filter from "./filter";
import _makeIterator_ from "../function/makeIterator_";
var exports = {};
var filter = _filter;
var makeIterator = _makeIterator_;
/**
 * Object reject
 */

function reject(obj, callback, thisObj) {
  callback = makeIterator(callback, thisObj);
  return filter(obj, function (value, index, obj) {
    return !callback(value, index, obj);
  }, thisObj);
}

exports = reject;
export default exports;